import { useCallback, useEffect, useState } from 'react';

const FB_TRACK_ID = '298334737236892';

// More info: https://developers.facebook.com/docs/facebook-pixel/advanced/advanced-matching
const advancedMatching = {}; // optional

// More info: https://developers.facebook.com/docs/facebook-pixel/advanced/
const options = {
  autoConfig: true, // set pixel's autoConfig
  debug: false, // enable logs
};

export default function useFacebookPixel(dispatch) {
  let pixel = null;
  const [events, setEvents] = useState({
    checkout: false,
    purchase: false,
    submitApplication: false,
    addToCart: false,
    initiateCheckout: false,
    trackViewContent: false,
    lead: false,
  });

  // track before purchase
  const trackFBCheckout = useCallback(
    (userId, prices, planActive) => {
      if (events.checkout) return;

      const data = {
        user: userId,
        currency: 'BRL',
        value: +prices.priceTotal,
        coupon: prices.codeCoupon,
        cart: [
          {
            id: planActive.product_id,
            name: planActive.product_name,
            frequency: planActive.plan_details.frequency,
            quantity: 1,
          },
        ],
      };
      TrackEvent('InitiateCheckout', data);
      setEvents({
        ...events,
        checkout: true,
      });
    },
    [pixel],
  );

  // track after purchase complete
  const trackFBPurchase = useCallback(
    (userId, prices, planActive) => {
      if (events.purchase) return;

      const data = {
        user: userId,
        currency: 'BRL',
        value: +prices.priceTotal,
        coupon: prices.codeCoupon,
        content_ids: [String(planActive?.product_id)],
        cart: [
          {
            id: planActive.product_id,
            name: planActive.product_name,
            frequency: planActive.plan_details.frequency,
            quantity: 1,
          },
        ],
      };

      TrackEvent('Purchase', data);
      setEvents({
        ...events,
        purchase: true,
      });
    },
    [pixel],
  );

  const trackSubmitApplication = useCallback(
    (data) => {
      if (events.submitApplication) return;
      TrackEvent('SubmitApplication', data);
      setEvents({
        ...events,
        submitApplication: true,
      });
    },
    [pixel],
  );

  const trackAddToCart = (productId, productPrice) => {
    if (events.addToCart) return;
    const body = {
      content_ids: [String(productId)],
      content_type: 'product',
      value: +productPrice,
      currency: 'BRL',
    };
    TrackEvent('AddToCart', body);
    setEvents({
      ...events,
      addToCart: true,
    });
  };
  const trackInitiateCheckout = useCallback(
    (productId, productPrice) => {
      if (events.initiateCheckout) return;
      const body = {
        content_ids: [String(productId)],
        content_type: 'product',
        value: +productPrice,
        currency: 'BRL',
      };
      TrackEvent('InitiateCheckout', body);
      setEvents({
        ...events,
        initiateCheckout: true,
      });
    },
    [pixel],
  );

  const trackViewContent = useCallback(
    (productId, productPrice) => {
      if (events.trackViewContent) return;
      if (!productId && !productPrice) {
        TrackEvent('ViewContent');
      } else {
        const body = {
          content_ids: [String(productId)],
          content_type: 'product',
          value: +productPrice,
          currency: 'BRL',
        };
        TrackEvent('ViewContent', body);
      }
      setEvents({
        ...events,
        trackViewContent: true,
      });
    },
    [pixel],
  );

  const trackLead = useCallback(() => {
    if (events.lead) return;
    TrackEvent('Lead');
    setEvents({
      ...events,
      lead: true,
    });
  }, [pixel]);

  useEffect(() => {
    import('react-facebook-pixel')
      .then((x) => x.default)
      .then((FBPixel) => {
        pixel = FBPixel;
        FBPixel.init(FB_TRACK_ID, advancedMatching, options);
        TrackEvent('pageView');
        if (dispatch === 'viewContent') {
          //trackViewContent()
        }
      });

    return () => {
      pixel = null;
    };
  }, []);

  const TrackEvent = useCallback(
    (event, data) => {
      return;
      //return pixel?.trackSingle(FB_TRACK_ID, event, data)
    },
    [pixel],
  );

  const TrackPageView = useCallback(() => {
    TrackEvent('pageView');
  }, [pixel]);

  return {
    trackFBCheckout,
    trackFBPurchase,
    trackSubmitApplication,
    trackAddToCart,
    trackInitiateCheckout,
    trackViewContent,
    trackLead,
    TrackPageView,
  };
}
